import * as Yup from 'yup';
import { stringRequired } from '.';

export const emailThreadSchema = Yup.object({
    message: Yup.string().test(
        'is-not-empty',
        'Message is required',
        (value) => {
            if (typeof value !== 'string') return false;
            return value.replace(/<(?:.|\n)*?>/gu, '').trim().length > 0;
        }
    )
});


export const messageComposeSchema = Yup.object({
    subject: stringRequired,
    body: Yup.string().test(
    'is-not-empty',
    'Message is required',
    (value) => {
      if (typeof value !== 'string') return false;
      return value.replace(/<(?:.|\n)*?>/gu, '').trim().length > 0;
    }
  )
});

export const inviteEmailSchema = Yup.object({
    email: stringRequired,
    subject: stringRequired,
    message: stringRequired
});